import axios from 'axios';

export default {
    namespaced: true,
    state: {
        all: [],
    },
    getters: {
        getAll(state) {
            return state.all;
        },
        byId(state) {
            return state.all.reduce((total, current) => {
                total[current.id] = current;
                return total
            }, {})
        },
    },
    actions: {
        index({ commit }) {
            return axios.get(process.env.VUE_APP_API_URL + 'hoses')
                .then(({ data }) => {
                    let ordered = data.filter(x => x.sort_order !== null)
                    let notOrdered = data.filter(x => x.sort_order === null)
                    ordered.sort((a, b) => a.sort_order - b.sort_order || JSON.stringify(a.title).localeCompare(JSON.stringify(b.title)));
                    notOrdered.sort((a, b) => JSON.stringify(a.title).localeCompare(JSON.stringify(b.title)));

                    commit('setHoses', [...ordered, ...notOrdered]);
                });
        },
    },
    mutations: {
        setHoses(state, hoses) {
            state.all = hoses;
        },
    },
};
